module.exports = __webpack_public_path__ + "img/logo certa 1.acc850c1.png";